import { QueryStore } from "./queryTypes";

export function selectRecentQueries(state: QueryStore) {
    return state.queries.recentQueries
}
